import ApiBase from '../api-base'
import { ACTIVE_BASE_REST } from '../constants'

export default class SupportedItem extends ApiBase {
  constructor(store) {
    const path = ACTIVE_BASE_REST + '/supported/item'
    super(store, path)
  }

  upsert(model, showProgress) {
    return this._request({
      action: 'upsert',
      method: 'PATCH',
      body: model,
      showProgress
    })
  }
}
